<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <div style="padding: 0px 180px 180px 180px;">
      <h4 class="color-secundary mb-4">{{ intro }}</h4>
      <div class="text-justify">
        <div v-html="recomendacion" style="padding: 0px 0px 15px 0px;"></div>
      </div>
      <div class="mt-3 text-right">
        <img
          v-if="loading"
          class="loading"
          src="@/assets/images/loader.gif"
          alt
        />
        <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
      </div>




        <b-card-group deck>
          <b-card title="Anexo de reclamación" style="max-width: 400px;" v-if="!loading && tipo_documentacion.portal_fga">
            <b-card-text>Espacio para carga de anexos relacionados a la reclamación de operaciones.</b-card-text>
            <b-button to="/carga/requerimientos-reclamacion/anexos-de-reclamacion" variant="primary">Ingresar</b-button>
          </b-card>
          <b-card title="Numero de cesión" style="max-width: 400px;" v-if="!loading && tipo_documentacion.custodiado_tercero">
            <b-card-text>Espacio para asignación de numeros de cesión relacionados a los cargues de reclamación.</b-card-text>
            <b-button to="/carga/requerimientos-reclamacion/numeros-de-cesion" variant="primary">Ingresar</b-button>
          </b-card>
          <b-card title="Certificación" style="max-width: 400px;" v-if="!loading && tipo_documentacion.custodiado_intermediario">
            <b-card-text>Espacio para cargar el archivo de certificación relacionado a los cargues reclamación de operaciones.</b-card-text>
            <b-button to="/carga/requerimientos-reclamacion/certificacion" variant="primary">Ingresar</b-button>
          </b-card>
          <b-card title="Actualización de clientes" style="max-width: 400px;" v-if="!loading && tipo_documentacion.actualizacion_clientes > 0">
            <b-card-text>Espacio para actualización de datos relacionados a los diferentes deudores</b-card-text>
            <b-button to="/carga/requerimientos-reclamacion/actualizacion-de-clientes" variant="primary">Ingresar</b-button>
          </b-card>
        </b-card-group>
      </div-->
      <b-row>
        <template v-for="documentacion in tipo_documentacion">
          <b-col cols="12" md="4" :key="documentacion.id" v-if="documentacion.visible">
            <div class="ficha">
              <div class="mt-5">
                <b-col>
                  <b-row style="height: 160px !important;">
                    <b-col>
                      <br />
                      <h5 class="color-black">{{documentacion.titulo}}</h5>
                      <p style="font-size: 12px;">{{documentacion.texto}}</p>
                    </b-col>
                  </b-row>
                  <b-row style="height: 50px !important;">
                    <b-col>
                      <b-button
                        class="button-carga"
                        style="margin:2%"
                        :to="documentacion.path"
                      >Ingresar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>
<script>
import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "RequerimientosReclamacion",
  data: () => {
    return {
      recomendacion: "En este espacio podrás cargar la documentación requerida para la reclamación",
      intro: "",
      tipo_documentacion: [
        {
          "id": "1",
          "visible": false,
          "titulo": "Anexo reclamación",
          "texto": "Espacio para carga de anexos para cada operación contenida en la reclamación",
          "path": "/carga/requerimientos-reclamacion/anexos-de-reclamacion"
        },
        {
          "id": "2",
          "visible": false,
          "titulo": "Numero Cesión",
          "texto": "Espacio para asignación de numeros de cesión relacionados a los cargues de reclamación.",
          "path": "/carga/requerimientos-reclamacion/numeros-de-cesion"
        },
        {
          "id": "3",
          "visible": false,
          "titulo": "Certificación",
          "texto": "Espacio para cargar el archivo de certificación relacionado a los cargues reclamación de operaciones.",
          "path": "/carga/requerimientos-reclamacion/certificacion"
        },
        {
          "id": "4",
          "visible": false,
          "titulo": "Actualización clientes",
          "texto": "Espacio para actualización de datos relacionados a los diferentes deudores",
          "path": "/carga/requerimientos-reclamacion/actualizacion-de-clientes"
        }
      ],
      loading: false,
    };
  },
  computed: {
    //
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
  },
  methods: {
    async getTipoDocumentacion() {
      this.loading = true;
      try {
        let request = await this.$store.state.api.get("/informes/tipo_documentacion", {
          params: {
           //
          },
        });
        this.tipo_documentacion = request.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
  },
  mounted() {
      this.getTipoDocumentacion();
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>